import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[Vyrti] UI crash:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6" data-testid="error-boundary">
          <h1 className="font-display font-bold text-3xl">Something went wrong</h1>
          <p className="text-zinc-500 mt-2 max-w-md">
            An unexpected error occurred. Your data is safe — try heading back home.
          </p>
          <button
            onClick={this.handleReload}
            className="mt-6 px-6 py-2.5 rounded-full bg-[#0654BA] text-white font-semibold hover:opacity-90 transition-opacity"
            data-testid="error-boundary-home-btn"
          >
            Back to home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
